<template>
  <div class="card" @click="onCardClick">
    <van-image class="image" :src="getFilePath(cardData.filePath)" />
    <div class="content">
      <div class="title">
        <span class="title-text van-ellipsis">{{ cardData.scenicName }}</span>
        <span class="level" v-if="cardData.scenicLevel > 0">({{ cardData.scenicLevel }}A)</span>
      </div>
      <div class="address van-ellipsis">
        <van-icon name="location" />
        <span>{{ cardData.address }}</span>
      </div>
      <div class="grade-box" v-if="tags.length !== 0">
        <template v-for="(tag, index) in tags">
          <span :key="index" class="tag" v-if="index <= 2 && theme[tag]">{{ theme[tag] }}</span>
        </template>
      </div>
      <div class="price-box">
        <ul v-if="cardData.canWin != 0.0" class="tags van-clearfix">
          <li class="active" v-if="commissionPrice >= 0">
            <span class="tips_icon">&yen;</span>
            <span class="tips_price">{{ commissionPrice }}</span>
          </li>
        </ul>
        <div v-if="distributionPrice">
          &yen;<span style="font-size: 18px;font-weight: 600;"> {{ distributionPrice }} </span>起
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'TicketProductListItem',
  props: {
    cardData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      DICTS: {
        scenic_theme: [],
      },
    };
  },
  computed: {
    theme: function () {
      return this.DICTS.scenic_theme.reduce((obj, curr) => {
        obj[curr.dictValue] = curr.dictLabel;
        return obj;
      }, {});
    },
    tags: function () {
      if(this.cardData.theme){
        return this.cardData.theme.split(',').filter(i => i);
      }else{
        return []
      }
    },
    distributionPrice: function () {
      // console.log(this.identityDeal, 'identityDealidentityDeal')
      return this.identityDeal
        ? this.cardData.minDealPrice
        : this.priceMap[this.cardData.scenicId]?.minDistributionPrice;
    },
    commissionPrice: function () {
      return this.priceMap[this.cardData.scenicId]?.maxCommissionPrice || -1;
    },
    // 判断是否展示利润
    ...mapGetters(['identityDeal']),
    ...mapGetters('ticket/list', ['priceMap']),
  },
  methods: {
    onCardClick() {
      const { cardCouponNo } = this.$route.query;
      const { scenicId, scenicName } = this.cardData;
      this.$router.push({
        path: '/home/productDetail/ticket_detail',
        query: { 
          scenicId,
          cardCouponNo,
          scenicName
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  height: vw(200);
  display: flex;
  justify-content: space-between;
  margin-bottom: vw(32);

  .image {
    width: vw(200);
    height: vw(200);
    background-color: #999999;
    border-radius: vw(8);
    overflow: hidden;
  }

  .content {
    height: 100%;
    width: calc(100% - vw(232));
    margin-left: vw(32);
    position: relative;
    .title {
      font-size: vw(28);
      padding: vw(5) 0;
      font-weight: bold;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .level {
        color: #00479C;
        font-weight: lighter;
        margin-left: vw(8);
      }
    }

    .grade-box {
      color: #8592A6;
      font-size: vw(22);
      display: flex;
      align-items: center;
      padding: vw(6) 0;

      > .tag {
        border: 1px solid #C2C5CC;
        padding: vw(4) vw(20);
        border-radius: vw(8);
        margin-right: vw(8);
      }

      > div {
        color: $theme-color;
        font-weight: bolder;
        margin-right: 0.5em;

        .grade {
          font-size: vw(30);
        }
      }
    }

    .address {
      color: #8592A6;
      font-size: vw(24);
      margin: vw(5) 0;
      overflow: hidden;
    }

    .price-box {
      font-size: vw(24);
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      bottom: 0;

      .tags {
        > li {
          float: left;
          border: 1px solid #ffefe0;
          padding: vw(6) vw(16);
          border-radius: vw(8);

          & + li {
            margin-left: 1em;
          }

          &.active {
            color: #ff781f;
            border-color: #ffefe0;
            background-color: #fff5eb;
            border-radius: vw(30);
          }
          .tips_icon {
            display: inline-block;
            width: vw(26);
            height: vw(26);
            font-size: vw(20);
            color: #fff;
            line-height: vw(27);
            text-align: center;
            background-color: #ff6900;
            border-radius: 50%;
          }
          .tips_price {
            font-weight: 600;
            margin-left: vw(8);
          }
        }
      }

      > div {
        position: absolute;
        right: vw(10);
        color: $theme-color;
        font-weight: bolder;
        text-align: right;
        .price {
          font-size: vw(30);
        }
      }
    }
  }
}
</style>
